<template>
	<div>
		
		<template v-if="headerShow">
			<div class="fzls">
				<div class="fzlsFor" :class="fzlsXz==index?'fzlsForXz':''" v-for="(item,index) in fzls" :key="index"
					@click="goClick(index)" @mouseenter="mouseover(index)">
					<div class="fzlsTime" :class="fzlsXz==index?'fzlsTimeOne':''">
						{{item.title}}
					</div>
					<div class="fzlsDb" v-if="fzlsXz==index" :class="fzlsXz==index?' ':''" style="animation-duration: .5s;">
						<ul>
							<li v-for="(itema,indexa) in item.desc" :key="indexa" class="fzlsDbWz">{{itema.text}}</li>
						</ul>
					</div>
					<div class="fzlsImg" v-if="fzlsXz==index&&item.cover">
						<img :src="item.cover" />
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="fzls">
				<div class="fzlsFor" :class="fzlsXz==index?'fzlsForXz':''" v-for="(item,index) in fzls" :key="index" @click="goClick(index)">
					<div class="fzlsTime" :class="fzlsXz==index?'fzlsTimeOne':''">
						{{item.title}}
					</div>
					<div class="fzlsDb" v-if="fzlsXz==index" :class="fzlsXz==index?' ':''" style="animation-duration: .5s;">
						<ul>
							<li v-for="(itema,indexa) in item.desc" :key="indexa" class="fzlsDbWz">{{itema.text}}</li>
						</ul>
					</div>
					<div class="fzlsImg" v-if="fzlsXz==index&&item.cover">
						<img :src="item.cover" />
					</div>
				</div>
			</div>
		</template>
		<!-- <div class="swiper-canpin fzls">
		<div class="swiper-wrapper ">
			<div class="swiper-slide fzlsFor"  :class="fzlsXz==index?'fzlsForXz':''" v-for="(item,index) in fzls" :key="index" @click="goClick(index)" @mouseenter="mouseover(index)">
				<div class="fzlsTime" :class="fzlsXz==index?'fzlsTimeOne':''">
					{{item.title}}
				</div>
				<div class="fzlsDb" v-if="fzlsXz==index"  :class="fzlsXz==index?' ':''" style="animation-duration: .5s;">
					<ul>
						<li v-for="(itema,indexa) in item.desc" :key="indexa" class="fzlsDbWz">{{itema.text}}</li>
					</ul>
				</div>
				<div class="fzlsImg" v-if="fzlsXz==index&&item.cover">
					<img :src="item.cover" />
				</div>
			</div>
		</div>
	</div> -->
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			fzls: {
				typeof: Array,
				default: []
			}
		},
		data() {
			return {
				fzlsXz: 0,
			}
		},
		mounted() {

		},
		mounted() {
			// const mySwiper = new this.$swiper('.swiper-canpin', {
			// 	// 方向
			// 	direction: 'horizontal',
			// 	slidesPerView: 'auto', // 每屏显示3个滑块
			// 	spaceBetween:30,
			// 	freeMode: false,
			// 	autoplay:false,
			// 	// 自动播放
			// 	// autoplay: {
			// 	// 	delay: 3000,
			// 	// 	disableOnInteraction: false,
			// 	// },
			// });
		},
		methods: {
			goClick(e) {
				console.log(e)
				if (this.fzlsXz == e) {
					this.fzlsXz = -1
				} else {
					this.fzlsXz = e;
				}
			},
			mouseover(e) {
				if (this.fzlsXz == e) {
					this.fzlsXz = -1
				} else {
					this.fzlsXz = e;
				}
			}
		}
	}
</script>

<style>
	.fzls::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}

	.fzls::-webkit-scrollbar-track {
		--webkit-box-shadow: inset 0 0 6px rgba(234, 234, 234, 1);
		border-radius: 10px;
		background: rgba(234, 234, 234, 1);
	}

	.fzls::-webkit-scrollbar-thumb {
		border-radius: 5px;
		background: #CFCFCF;
		--webkit-box-shadow: inset 0 0 6px rgba(234, 234, 234, 1);
	}

	.fzls::-webkit-scrollbar-thumb:window-inactive {
		background: rgba(234, 234, 234, 1);
		border-radius: 10px;
	}

	.fzlsDb::-webkit-scrollbar {
		opacity: 0;
	}
</style>
<style scoped lang="scss">
	.swiper-canpin {
		width: 1200px;
		overflow: hidden;
	}

	.fzls {
		width: 1200px;
		overflow-x: auto;
		margin-bottom: 137px;
		display: flex;

		.fzlsFor:hover {
			border-left: 1px solid #000;

			.fzlsTime {
				color: #000;
			}
		}

		.fzlsFor:last-child {
			border-right: 1px solid #9A9A9A;
		}

		.fzlsFor {
			flex-shrink: 0;
			width: 100px;
			min-width: 100px;
			// max-width: 312px;
			flex: 1;
			cursor: pointer;
			transition: all 0.3s ease-in-out;
			height: 550px;
			border-left: 1px solid #9A9A9A;
			display: flex;
			flex-direction: column;
			overflow-y: hidden;

			.fzlsTime {
				text-align: center;
				font-size: 35px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #BDBDBD;
				margin-top: 67px;
				margin-bottom: 16px;
			}

			.fzlsTimeOne {
				color: #001489;
			}

			.fzlsDb {
				flex: 1;
				transition: all 0.3s ease-in-out;
				opacity: 0;
			}

			.fzlsImg {
				width: 100%;
				height: 200px;
				display: flex;
				align-items: flex-end;

				img {
					width: 100%;
					// object-fit:cover;
					// height: 187px;
					object-fit: contain;
					object-position: bottom;
				}
			}
		}

		.fzlsForXz:hover {
			border-left: 1px solid #9A9A9A;

			.fzlsTime {
				color: #001489;
			}
		}

		.fzlsForXz {
			flex: initial;
			min-width: 190px;

			// min-width: 322px;
			.fzlsTime {
				padding: 0 10px;
				text-align: left;
				color: #001489;
			}

			.fzlsDb {
				overflow-y: auto;
				padding: 0 30px;
				opacity: 1;

				.fzlsDbWz {
					min-height: 36px;
					font-size: 14px;
					font-family: Source Han Sans CN;
					font-weight: 300;
					color: #000000;
					// cursor: pointer;
					white-space: pre-line;
				}
			}
		}
	}

	@media screen and (max-width:1200px) {
		.fzls {
			width: calc(100% - 60px) !important;
			margin: 0 30px 30px !important;
			box-sizing: border-box;
		}
	}
</style>